module.exports = __webpack_public_path__ + "static/favicon-04ae7cdc7069991750171b63f0514833.ico";